(() => {
    class Notifications extends App.Entities.Base {
        constructor() {
            super();
            this.notifications = {};
            this.defaultContainerName = 'default';
        }

        setDefaultContainer(containerName) {
            this.defaultContainerName = containerName;
            return this;
        }

        set(notification, container = this.defaultContainerName) {
            this.add(container, notification);
            return this;
        }

        add(
            container,
            message,
            type = null,
            icon = null,
            close = null,
            layout = 'standard',
            timer = 0,
            title = '',
            action = null
        ) {
            let notification;
            if (message instanceof App.Entities.Notification) {
                notification = message;
            } else {
                notification = new App.Entities.Notification();
                notification.message    = message;
                notification.type       = type;
                notification.icon       = (icon);
                notification.close      = (close);
                notification.layout     = layout;
                notification.timer      = timer;
                notification.title      = title;
                notification.action     = action;
            }
            if (!container) container = this.defaultContainerName;
            if (!(container in this.notifications)) this.notifications[container] = [];
            this.notifications[container].push(notification);

            return this;
        }

        remove(container = this.defaultContainerName, index) {
            if (this.notifications[container] !== undefined)
                this.notifications[container].splice(index, 1);
            return this;
        }

        reset() {
            for (let container in this.notifications) this.notifications = [];
            return this;
        }

        get() {
            return this.notifications;
        }

        getByContainer(container = this.defaultContainerName) {
            return this.notifications[container];
        }
    }
    App.Entities.Notifications = Notifications;
})();
